import { LoggedInUser } from '@ekkogmbh/apisdk';
import { Box, Divider, Paper, Stack, useMediaQuery, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import useEkko from 'src/Common/Providers/EkkoProvider';
import useRequest from 'src/Common/Hooks/useRequest';
import { SettingsContext } from './SettingsContext';
import { SettingsNav } from './SettingsNav';

export const SettingsLayout = (): React.JSX.Element => {
  const { api } = useEkko();
  const theme = useTheme();
  const isRow = useMediaQuery(theme.breakpoints.up('md'));

  const [isLoading, startLoading] = useRequest<LoggedInUser>();
  const [user, setUser] = useState<LoggedInUser | undefined>(undefined);

  const refetch = useCallback(() => {
    startLoading(
      () => api.getCurrentUser(),
      (usr) => setUser(usr),
    );
  }, [api]);

  /** on mount */
  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <SettingsContext.Provider value={{ user, isLoading, refetch }}>
      <Paper variant={'outlined'} sx={{ width: '100%', overflow: 'hidden' }}>
        <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'stretch'} sx={{ width: '100%' }}>
          <Box sx={{ flexShrink: 0, minWidth: { md: 240 }, py: 1 }}>
            <SettingsNav />
          </Box>
          <Divider orientation={isRow ? 'vertical' : 'horizontal'} flexItem />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Outlet />
          </Box>
        </Stack>
      </Paper>
    </SettingsContext.Provider>
  );
};
